/* eslint-disable no-nested-ternary */
import React from 'react';

import BlockContent from './BlockContent';

function Article({ article }) {
  const { markdownContent, publishedAt, title, subtitle } = article;
  console.log(subtitle);
  return (
    <>
      {article && (
        <div className="article">
          <BlockContent
            content={{
              subtitle: subtitle?.childMarkdownRemark?.rawMarkdownBody || title,
              description: markdownContent
            }}
          />

          {publishedAt && (
            <figcaption className="body --x-small">{publishedAt}</figcaption>
          )}
        </div>
      )}
    </>
  );
}

export default Article;
